import { createAsyncThunk } from '@reduxjs/toolkit'
import { callErrorMsg } from 'helpers/errorMsg'
import {
  getCampaignUmbrellaList,
  GetCampaignUmbrellaListRequestType,
  deleteCampaignUmbrella,
} from 'features/CampaignAndDiscount/services/campaignUmbrella'
import { toastFailed, toastSuccess } from 'utils/toast'
import { SLICE_NAME, setIsLoading, setList } from './slice'

const validateParamsValue = (
  key: keyof GetCampaignUmbrellaListRequestType['params'],
  value: string | number | undefined | null,
) =>
  value
    ? {
        [key]: value,
      }
    : {}

export const fetchCampaignUmbrellaList = createAsyncThunk(
  `${SLICE_NAME}/fetchCampaignUmbrellaList`,
  async (_, { dispatch, rejectWithValue, getState }) => {
    const {
      campaignUmbrellaList: { query },
    } = getState() as StoreStateType
    dispatch(setIsLoading(true))

    try {
      const { data } = await getCampaignUmbrellaList({
        params: {
          page_index: query.page_index,
          page_size: query.page_size,
          ...validateParamsValue('submission_status', query.status.value),
          ...validateParamsValue('campaign_theme', query.campaign_theme),
          ...validateParamsValue(
            'created_at',
            query.created_at ? `${query.created_at}T00:00:00Z` : undefined,
          ),
        },
      })

      if (data.error.status) {
        toastFailed(data.error.message)
      } else {
        dispatch(setList(data.data))
      }
      dispatch(setIsLoading(false))

      return data
    } catch (error) {
      callErrorMsg(error)
      dispatch(setIsLoading(false))
      return rejectWithValue(error)
    }
  },
)

export const removeCampaignUmbrella = createAsyncThunk(
  `${SLICE_NAME}/removeCampaignUmbrella`,
  async (brandSubmissionID: string, { rejectWithValue }) => {
    try {
      const { data } = await deleteCampaignUmbrella({ brandSubmissionID })
      if (data.error.status) {
        toastFailed(data.error.message)
      }
      toastSuccess(data.message)
      return data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)
